import React, { useEffect, useCallback } from 'react';
import { Row, Col, Select, Button, Form } from 'antd';

const SelectType = ({
  question,
  selectedAnswer,
  options,
  buttonsState,
  onSubmitAnswer,
  selectedOption,
  setSelectedOption,
  isMultiple = false,
}) => {
  const [form] = Form.useForm();

  const getInitialArray = (value) => {
    if (!value || (typeof value === 'string' && value.trim() === '')) return [];
    if (Array.isArray(value)) return value;
    return value.split(',').map(item => item.trim()).filter(Boolean);
  };

  const setFieldValue = useCallback(
    () => {
      if (isMultiple) {
        setSelectedOption([]);
        if (selectedAnswer) {
          const answerArray = getInitialArray(selectedAnswer);
          form.setFieldsValue({ range: answerArray });
          setSelectedOption(selectedAnswer);
        }
      } else {
        setSelectedOption();
        if (selectedAnswer) {
          form.setFieldsValue({ range: selectedAnswer });
          setSelectedOption(selectedAnswer);
        }
      }
    },
    [selectedAnswer, question, isMultiple],
  );

  const onFinish = (type) => {
    let answerToSave;
    
    if (isMultiple) {
      answerToSave = Array.isArray(selectedOption) 
        ? selectedOption.join(', ') 
        : selectedOption;
    } else {
      answerToSave = form.getFieldValue("range");
    }
    
    onSubmitAnswer(type, answerToSave);
    form.resetFields();
  };

  const handleSelect = (event) => {
    if (!isMultiple) {
      setSelectedOption(event);
      return;
    }
    let formatedSelect = Array.isArray(event) 
            ? event.join(',') 
            : event;
    setSelectedOption(formatedSelect);
  };

  const isDisabled = () => {
    if (isMultiple) {
      return buttonsState.isCurrentLastQuestion 
        ? !selectedOption || selectedOption.length === 0 
        : buttonsState.lastQuestion && buttonsState.questionsUnanswered;
    } else {
      return buttonsState.isCurrentLastQuestion 
        ? !selectedOption 
        : buttonsState.lastQuestion && buttonsState.questionsUnanswered;
    }
  };

  useEffect(() => {
    form.resetFields();
    setFieldValue();
  }, [setFieldValue]);

  return (
    <Row justify="center">
      <Form
        initialValues={{ range: isMultiple ? getInitialArray(selectedAnswer) : selectedAnswer }}
        form={form}
        style={{ width: '100%' }}
      >
        <Col md={24}>
          <Row justify="center">
            <Col md={24} className="options-wrapper p-40 mt-40 mb-80">
              <Row justify="center">
                <Col md={24}>
                  <h2 className="text-center mt-10 mb-50" dangerouslySetInnerHTML={{ __html: question.title && question.title }} />
                </Col>
                <Col md={10}>
                  <Form.Item name="range" className="mb-0">
                    <Select
                      mode={isMultiple ? "multiple" : undefined}
                      onChange={handleSelect}
                      style={{ width: '100%', fontSize: '22px' }}
                      placeholder={question.title && question.title}
                      size="large"
                      maxTagCount={isMultiple ? "responsive" : undefined}
                      allowClear={isMultiple}
                    >
                      {
                        options && options.map((option, index) =>
                          <Select.Option
                            key={index}
                            value={option.text.toString()}
                            style={{ fontSize: '22px' }}
                          >
                            {option.text}
                          </Select.Option>
                        )
                      }
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="mb-40">
            <Col md={5}>
              <Button
                className={'secondary-button'}
                size="large"
                onClick={() => onFinish('previus')}
                block
              >
                Anterior
              </Button>
            </Col>
            <Col md={buttonsState.isCurrentLastQuestion ? 12 : 14}></Col>
            <Col md={buttonsState.isCurrentLastQuestion ? 7 : 5} justify="end">
              <Button
                disabled={isDisabled()}
                className={isDisabled() ? 'button-disabled' : ''}
                type="primary"
                size="large"
                onClick={() => onFinish('foward')}
                block
              >
                {buttonsState.isCurrentLastQuestion ? 'Terminar cuestionario' : 'Siguiente'}
              </Button>
            </Col>
          </Row>
        </Col>
      </Form>
    </Row>
  );
};

export default SelectType;